export const wix = (uri, w, h) =>
  `https://static.wixstatic.com/media/${uri}/v1/fill/w_${w},h_${h},al_c,q_85,enc_avif,quality_auto/${uri}`;

const U = {
  walk: "ddf3da_9994f88265e54d628ad4b3141062adc9~mv2.jpg",
  tentInterior: "ddf3da_0f72ef292cf74d558eca99bc26003487~mv2.jpg",
  barbets: "ddf3da_1f4e63d9cf68456788a375305e087416~mv2.jpg",
  lodgeFire: "ddf3da_6b0ce308a3ff489197358672cc33db67~mv2.jpg",
  lodgeNight: "ddf3da_50c99fb60ef547de863e02f14c592f4e~mv2.jpg",
  tigerNight: "ddf3da_6113ef788ac94129893067c6a893c31a~mv2.jpg",
  tigerFeeding: "ddf3da_841fbb1e58dc40a7a47a8ed73d8eb85f~mv2.jpg",
  tigerDay: "ddf3da_ac0a6350d13a4f24b61db0efd10c1308~mv2.jpg",
  leopardNight: "ddf3da_3ffb97c5bf8440d1bdddd22a47410f48~mv2.jpg",
  deerReflection: "ddf3da_40e289e1870f41b2a2ae0a2e8a841358~mv2.jpg",
  elephantsBank: "ddf3da_6465f7f020d74c9f92b2dd2cb40b2e36~mv2.jpg",
  elephantsRiver: "ddf3da_b61d118fdfda4ca687aeb4450023592c~mv2.jpg",
  dusk: "ddf3da_aada7e82f22c4a7b85971f0089b9e2a5~mv2.jpg",
  owlet: "ddf3da_0c6279300b5d42edafbffc21b613aa7f~mv2.jpg",
  beeEater: "ddf3da_0787a8c03ca345d1a3f3fe1ca85d7994~mv2.jpg",
  whiteEye: "ddf3da_0a1c6b1202f0498cae4cd57dffd40fb6~mv2.jpg",
  drongo: "ddf3da_2bc0a9fd63734d9bbd51ae3ea7894b74~mv2.jpg",
  peafowl: "ddf3da_8df2acde6d2d4ee2917c5c55aac8e417~mv2.jpg",
  canopyBird: "ddf3da_9191d3bc594b462bb90ba2c03906255f~mv2.jpg",
  woodpecker: "ddf3da_c2c705a324074a57b7c2890c05209ec2~mv2.jpg",
  elephantSal: "ddf3da_ece82ed0691b452cbf2ba326e88799b6~mv2.jpg",
  snake: "ddf3da_fa2218aab4154b19933142e0ab7bce32~mv2.jpg",
  mantis: "ddf3da_0f6eaab1e7414a6090b961dad4179ccd~mv2.jpg",
  deerTrap: "ddf3da_30ff60bccfc5428bb6ffb47114c1d1bb~mv2.jpg",
  civet: "ddf3da_3591c3f23f7541b6832a4575d2ffc48a~mv2.jpg",
  leopardRocks: "ddf3da_600c33d4649b4df69b82700151f92090~mv2.jpg",
  tigerLamp: "ddf3da_7c809fb99ffc42f0b88d599784bbafa5~mv2.jpg",
  cub: "ddf3da_91225a56d0e04212a7a78cb817524347~mv2.jpg",
};

export function resolveImage(ref, w = 1080, h = 1080) {
  if (!ref) return "";
  if (ref.startsWith("http")) return ref;
  const uri = U[ref] || (ref.includes("~mv2") ? ref : null);
  return uri ? wix(uri, w, h) : ref;
}

// Owner-supplied real photographs (hosted assets) — used to replace repeated stock crops
const A = {
  golGhar: "https://customer-assets-7cd3h4nn.emergentagent.net/job_forest-walk-5/artifacts/9irffr1g_IMG_6299.webp",
  snakeNight: "https://customer-assets-7cd3h4nn.emergentagent.net/job_forest-walk-5/artifacts/ke4c0gro_Untitled.jpg",
  tigerKill: "https://customer-assets-7cd3h4nn.emergentagent.net/job_forest-walk-5/artifacts/dw14vqy3_3c845c2e-c528-4bc0-9500-d174d3e508cc.JPG",
  tigerWalk: "https://customer-assets-7cd3h4nn.emergentagent.net/job_forest-walk-5/artifacts/3ldrw4bo_37d54a6b-2811-4778-a9db-9825c2d397af.JPG",
  leopardWalk: "https://customer-assets-7cd3h4nn.emergentagent.net/job_forest-walk-5/artifacts/m8oe5ag0_a606b5a0-b281-48e3-adaf-7e682addae06.JPG",
};

export const IMG = {
  heroPoster: wix(U.walk, 1920, 1080),
  salRiver: wix(U.walk, 1600, 2000),
  salTall: wix(U.walk, 900, 1200),
  golGhar: A.golGhar,
  lodgePano: wix(U.tentInterior, 1920, 900),
  lodgePanoTall: wix(U.tentInterior, 900, 1100),
  misty: wix(U.barbets, 1920, 1280),
  mistyTall: wix(U.barbets, 900, 1100),
  walkForest: wix(U.walk, 800, 1000),
  cameraTrap: A.tigerKill,
  photoHide: A.leopardWalk,
  birding: wix(U.barbets, 800, 1000),
  nightAstro: wix(U.dusk, 800, 1000),
  bushDining: wix(U.lodgeFire, 800, 1000),
  wildlife1: A.tigerWalk,
  wildlife2: wix(U.deerReflection, 1080, 1080),
  wildlife3: A.snakeNight,
  river: wix(U.elephantsRiver, 1920, 900),
  journal1: wix(U.owlet, 800, 600),
  journal2: wix(U.elephantsRiver, 800, 600),
  journal3: wix(U.walk, 800, 600),
};

export const HERO_VIDEO =
  "https://video.wixstatic.com/video/ddf3da_3add3ff9ed9f4cb69ae3341045835456/1080p/mp4/file.mp4";

export const DAWN_CHORUS = {
  mp3: "https://upload.wikimedia.org/wikipedia/commons/transcoded/d/de/Dawnchorus-uk.ogg/Dawnchorus-uk.ogg.mp3",
  ogg: "https://upload.wikimedia.org/wikipedia/commons/d/de/Dawnchorus-uk.ogg",
};

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hello, I would like to plan a stay at The Jamoon, Corbett."
)}`;
export const CONTACT_EMAIL = "corbett@thejamoon.com";
export const CONTACT_PHONE = "+91 98713 84780";
export const CALL_NUMBER = "+91 98713 84780";
export const CALL_LINK = "tel:+919871384780";

export const NAV_LINKS = [
  { label: "STAY", to: "/stay" },
  { label: "EXPERIENCES", to: "/experiences" },
  { label: "WILDLIFE", to: "/wildlife" },
  { label: "CONSERVATION", to: "/conservation" },
  { label: "THE JOURNEY", to: "/journey" },
  { label: "PACKAGES", to: "/packages" },
  { label: "GALLERY", to: "/gallery" },
  { label: "JOURNAL", to: "/journal" },
];

export const STATS = [
  { value: "05", label: "TENTS" },
  { value: "1318", label: "SQKMS OF FOREST" },
  { value: "01", label: "RIVER" },
  { value: "3.5 KM", label: "FOREST WALK" },
];

export const EXPERIENCES = [
  { title: "Walk the Forest", text: "Trails begin where your tent ends. Walk them with seasoned naturalists — the forest reads entirely differently on foot.", image: "walkForest" },
  { title: "Camera Traps", text: "Deploy the lodge's own trail cameras — or bring yours — and let the forest reveal what passes through the night.", image: "cameraTrap" },
  { title: "The Photo Hide", text: "A hide overlooking a private waterhole, frequented by creatures of day and night. Wait quietly. Watch.", image: "photoHide" },
  { title: "Birding", text: "More than 300 species in and around the lodge — some permanent residents. A bird hide waits within the property.", image: "birding" },
  { title: "Night & Astro", text: "No electricity for miles means a sky lit only by stars. Night photography, backlit macro, the whole galaxy.", image: "nightAstro" },
  { title: "Bush Dining", text: "Meals made from what grows in and around the lodge, served where the forest can see you.", image: "bushDining" },
];

export const DINING = [
  { title: "Bush Breakfast", text: "The first meal carried out to the forest edge, as the birds begin." },
  { title: "Riverside Lunch", text: "Eaten slowly, within earshot of the Ramganga." },
  { title: "Bush Dinner", text: "Lamplight, fire, and the sounds of the night shift arriving." },
  { title: "Under the Stars", text: "No roof, no glow on the horizon — just the sky, undimmed." },
];

export const JOURNEY_STEPS = [
  { name: "DHIKULI", note: "The edge of the everyday — shops, signal, tarmac." },
  { name: "BHASEDI", note: "A small village where the road, quite literally, ends." },
  { name: "THE FOREST", note: "You shoulder a light bag. The sal closes over the path." },
  { name: "3.5 KM", note: "Walked, not driven. The forest decides what you notice." },
  { name: "RAMGANGA", note: "The river announces itself before you see it." },
  { name: "THE JAMOON", note: "Five tents. Ten acres. You have arrived on foot, as one should." },
];

export const JOURNAL = [
  { title: "Notes from the Photo Hide", slug: "notes-from-the-photo-hide", tag: "Field Notes", text: "Hours of stillness at the waterhole, and what the patient are given.", image: U.owlet, imageAlt: "An owlet perched near the photo hide at The Jamoon", created_at: "2026-01-12T06:30:00+00:00", updated_at: "2026-01-12T06:30:00+00:00" },
  { title: "The River in Winter", slug: "the-river-in-winter", tag: "Ramganga", text: "Mist on the water at first light, and the forest waking in layers.", image: U.elephantsRiver, imageAlt: "Elephants gathered on the Ramganga bank near The Jamoon", created_at: "2026-02-03T06:30:00+00:00", updated_at: "2026-02-03T06:30:00+00:00" },
  { title: "Walking the 3.5", slug: "walking-the-3-5", tag: "The Journey", text: "Why the last kilometres to The Jamoon are walked, and always will be.", image: U.walk, imageAlt: "Forest path leading to The Jamoon in Corbett", created_at: "2026-02-21T06:30:00+00:00", updated_at: "2026-02-21T06:30:00+00:00" },
];

export const JOURNAL_IMAGE_ALTS = Object.fromEntries(JOURNAL.map((entry) => [entry.slug, entry.imageAlt]));

export const GALLERY_CATEGORIES = [
  { key: "wildlife", label: "Wildlife" },
  { key: "river", label: "The River" },
  { key: "forest", label: "The Forest" },
  { key: "tents", label: "Tents & Lodge" },
  { key: "night", label: "Night & Sky" },
];

export const GALLERY = [
  { uri: A.tigerWalk, caption: "A tiger walks the night trail — camera-trap, The Jamoon", category: "wildlife" },
  { uri: A.leopardWalk, caption: "A leopard crosses the riverbed after dark — The Jamoon", category: "wildlife" },
  { uri: A.tigerKill, caption: "A tiger returns to its kill — camera-trap, The Jamoon", category: "wildlife" },
  { uri: A.snakeNight, caption: "A bronzeback at night, tongue testing the air — The Jamoon", category: "wildlife" },
  { uri: "ddf3da_0787a8c03ca345d1a3f3fe1ca85d7994~mv2.jpg", caption: "A bee-eater at breakfast — photographed at The Jamoon", category: "wildlife" },
  { uri: "ddf3da_2bc0a9fd63734d9bbd51ae3ea7894b74~mv2.jpg", caption: "A drongo on its lookout post — photographed at The Jamoon", category: "wildlife" },
  { uri: "ddf3da_0c6279300b5d42edafbffc21b613aa7f~mv2.jpg", caption: "An owlet holds still — photographed at The Jamoon", category: "wildlife" },
  { uri: "ddf3da_6465f7f020d74c9f92b2dd2cb40b2e36~mv2.jpg", caption: "Elephants on the Ramganga bank — photographed at The Jamoon", category: "river" },
  { uri: "ddf3da_0f72ef292cf74d558eca99bc26003487~mv2.jpg", caption: "Inside a Jamoon tent — photographed at The Jamoon", category: "tents" },
  { uri: A.golGhar, caption: "The Gol Ghar after dark — The Jamoon", category: "tents" },
  { uri: "ddf3da_aada7e82f22c4a7b85971f0089b9e2a5~mv2.jpg", caption: "Dusk settles over the valley — photographed at The Jamoon", category: "night" },
];

// Pulled from thejamoon.com/packages
export const PACKAGE_FEATURES = [
  "True 'Raw Wilderness' experience",
  "Stay in luxury tents — Corbett style",
  "Walking Safaris next to the Ramganga River",
  "Magical dawn, dusk & night skies",
  "Remote & camera-trap photography",
  "Bird-watching: 400+ species of birds",
  "Photography through hides near a private waterhole",
  "Pug-mark casting",
  "Bonfire evenings under the stars",
  "Authentic local cuisine & jungle-theme meals",
];

export const PACKAGES = [
  {
    name: "Jamoon Explorer Plan",
    slug: "jamoon-explorer",
    duration: "4 Nights & 5 Days",
    price: "INR 1,40,000",
    priceNote: "+ applicable taxes · per couple",
    tagline: "Our signature stay — with sundowners, a bush dinner & barbeque.",
    featured: true,
    image: "bushDining",
    imageAlt: "Fireside bush dining at The Jamoon in Corbett",
    inclusions: [
      "Dhikuli – Jamoon – Dhikuli transfers",
      "3 nights' accommodation at Jamoon Bush Lodge with meals (for a couple)",
      "1 night's accommodation at Corbett Hideaway, Ramnagar with meals",
      "One Bush Breakfast on the banks of the Ramganga River",
      "01 Evening Sundowner with complimentary drinks* (liquor courtesy Himalayan Spirits)",
      "01 Bush Dinner with Barbeque and complimentary drinks* (liquor courtesy Himalayan Spirits)",
      "Services of an accompanying Naturalist / Guide throughout the trip",
      "Guided nature walks",
      "All wildlife observation arrangements, including binoculars and trail cameras",
      "Daily access to photography hides for specific hours",
      "Packaged mineral water during treks and at the lodge",
    ],
    footnote: "*Alcohol subject to availability.",
  },
  {
    name: "Corbett Discovery Plan",
    slug: "corbett-discovery",
    duration: "4 Nights & 5 Days",
    price: "INR 1,10,000",
    priceNote: "+ applicable taxes · per couple",
    tagline: "The essential Jamoon experience, walks, hides and the river.",
    featured: false,
    image: "walkForest",
    imageAlt: "Forest path leading to The Jamoon in Corbett",
    inclusions: [
      "Dhikuli – Jamoon – Dhikuli transfers",
      "3 nights' accommodation at Jamoon Bush Lodge with meals (for a couple)",
      "01 night's accommodation at Corbett Hideaway, Ramnagar with meals",
      "01 Bush Breakfast by the river",
      "Guided nature walks",
      "Services of an accompanying Naturalist / Guide throughout the trip",
      "All wildlife observation arrangements, including binoculars and trail cameras",
      "Daily access to photography hides for specific hours",
      "Packaged mineral water during treks and at the lodge",
    ],
    footnote: "For customised itineraries, write to corbett@thejamoon.com.",
  },
];

export const PACKAGE_TERMS = [
  "Booking is confirmed only on receipt of full advance payment.",
  "Rates are valid for Indian & Foreign Nationals, except blackout dates (Christmas & New Year's Eve).",
  "Check-out 1200 hrs · Check-in 1300 hrs. Unconfirmed arrivals are released at 1800 hrs.",
  "Cancellation: within 15 days of arrival / no-show — no refund; 15–30 days — 50% of package cost; 30 days & more — no deduction.",
  "Refunds carry a 25% cancellation charge. Rates & availability are dynamic and may change without notice.",
  "We accept UPI, Visa & Master Credit/Debit cards and bank transfers only. All jurisdiction under the District of Nainital.",
];

// Day-by-day itineraries, keyed by package slug
export const ITINERARIES = {
  "jamoon-explorer": [
    { day: "Day 01", title: "The Long Walk In", items: ["Dhikuli → Bhasedi road transfer, where the tarmac ends", "Walk the final 3.5 km through the sal forest to the lodge", "Settle into your tent as the forest quietens", "Evening sundowner by the Ramganga with complimentary drinks", "Dinner at the lodge under lamplight"] },
    { day: "Day 02", title: "Forest & Hide", items: ["Dawn chorus from the in-house bird hide", "Breakfast at the lodge", "Walking safari along the banks of the Ramganga", "Afternoon in the photographic hide over the private waterhole", "Bush Dinner with barbeque under the stars, drinks courtesy Himalayan Spirits"] },
    { day: "Day 03", title: "River & Night Sky", items: ["Bush Breakfast on the banks of the Ramganga", "Trail-camera deployment & monitoring with your naturalist", "Pug-mark casting from the morning's prints", "Night & astro photography under a genuinely dark sky", "Campfire to close the day"] },
    { day: "Day 04", title: "Last Morning, Soft Landing", items: ["One final morning walk and hide session", "Walk out and transfer to Corbett Hideaway, Ramnagar", "Comfort night with meals on the edge of the Reserve"] },
    { day: "Day 05", title: "Departure", items: ["Unhurried breakfast", "Corbett Hideaway → Dhikuli transfer, and onward"] },
  ],
  "corbett-discovery": [
    { day: "Day 01", title: "The Long Walk In", items: ["Dhikuli → Bhasedi road transfer, where the tarmac ends", "Walk the final 3.5 km through the sal forest to the lodge", "Settle into your tent", "Evening guided nature walk", "Dinner at the lodge under lamplight"] },
    { day: "Day 02", title: "Birds, Walks & the Hide", items: ["Dawn chorus from the in-house bird hide", "Breakfast at the lodge", "Guided nature walk along the Ramganga", "Afternoon in the photographic hide over the private waterhole", "Campfire evening"] },
    { day: "Day 03", title: "River & Trails", items: ["Bush Breakfast by the river", "Trail-camera monitoring and pug-mark casting", "Birding across the lodge's 400+ species", "Stargazing under an unlit sky"] },
    { day: "Day 04", title: "Last Morning, Soft Landing", items: ["Morning walk through the forest", "Walk out and transfer to Corbett Hideaway, Ramnagar with meals"] },
    { day: "Day 05", title: "Departure", items: ["Breakfast at the Hideaway", "Corbett Hideaway → Dhikuli transfer, and onward"] },
  ],
};

export const MARQUEE_WORDS = [
  "WILDERNESS",
  "RAMGANGA",
  "SAL FOREST",
  "FOOTSTEPS",
  "NIGHT SKY",
  "STILLNESS",
  "BIRDCALL",
  "THE LONG WALK IN",
];
